import React, { useState, useContext } from "react";
import ProgresoPartidaChart from "../charts/ProgresoPartidaChart";
import { ProyectosContext } from "../../context/ProyectosContext";
import { PartidasContext } from "../../context/PartidasContext";
import { ModalContext } from "../../context/ModalContext";
import ColorLegend from "../common/ColorLegend";
import Retrasos from "./Retrasos";

const MOBILE_BREAKPOINT = 992;

const TrabajosRetrasados = () => {
  const [selectedPartida, setSelectedPartida] = useState(null);
  const { proyecto } = useContext(ProyectosContext);
  const { partidas } = useContext(PartidasContext);
  const { modalComponent } = useContext(ModalContext);
  const { idProyecto, permiso } = proyecto;

  function handleClick(idPartida) {
    const isMobile = window.innerWidth < MOBILE_BREAKPOINT;
    if (isMobile && Array.isArray(partidas)) {
      const currentPartida = partidas.find(
        (partida) => partida.idPartida === idPartida
      );
      if (currentPartida) {
        modalComponent(
          "Comentarios",
          <Retrasos
            idProyecto={idProyecto}
            partida={currentPartida}
            permiso={permiso}
          />
        );
      }
      return;
    }
    setSelectedPartida(idPartida);
  }

  function renderRetrasos() {
    if (selectedPartida && Array.isArray(partidas)) {
      const currentPartida = partidas.find(
        (partida) => partida.idPartida === selectedPartida
      );
      if (currentPartida) {
        return (
          <Retrasos
            idProyecto={idProyecto}
            partida={currentPartida}
            permiso={permiso}
          />
        );
      }
    }
    return <p>Selecciona una partida para mostrar comentarios</p>;
  }

  const renderChart = () => {
    if (Array.isArray(partidas)) {
      return partidas.map((partida) => (
        <ProgresoPartidaChart key={partida.idPartida} partida={partida} handleClick={handleClick} />
      ));
    }
  };

  return (
    <div className="row">
      <div className="col-md-12 col-lg-6 col-xl-8">
        <div className="row mb-3 align-items-center">
          <div className="col-12">
            <h4 className="mb-2">Progreso por Partida</h4>
          </div>
          <div className="col-12">
            <ColorLegend colors={colors} block={false} />
          </div>
        </div>
        <div className="container-fluid px-0">{renderChart()}</div>
        <div className="container-fluid pt-2 px-0">
        </div>
      </div>
      <div className="col-lg-6 col-xl-4 d-none d-lg-block">
        <div
          style={{
            position: "sticky",
            top: "80px",
            maxHeight: "calc(100vh - 100px)",
            overflowY: "auto",
            paddingBottom: "70px",
          }}
        >
          <h4>Comentarios</h4>
          {renderRetrasos()}
        </div>
      </div>
    </div>
  );
};

const colors = [
  { title: "Real", color: "#89d405", className: "real-gradiente" },
  { title: "Programado", color: "#007991", className: "programado-gradiente" },
  { title: "Retraso 5-10%", color: "#ff8008", className: "pagos-gradiente" },
  { title: "Retraso >10%", color: "#dc3545", className: "diferencial-gradiente" },
];

export default TrabajosRetrasados;
